import _ from 'lodash'
import { Signout } from '@/components'
import { useGlobalStore } from '@/store/provider'

export function AdminUser() {
  const { user, onlineAdminUsers } = useGlobalStore((state) => state)
  return (
    <div className='w-full pb-8 border-t divide-y mt-6'>
      <div className='px-8 py-2 bg-zinc-100 dark:bg-zinc-800'>
        <span className='text-base font-semibold pr-2'>{_.size(onlineAdminUsers)}</span>
        <span className='text-xs font-light'>Online Admin Users</span>
      </div>
      <div className='px-6 py-4'>
        <div className='text-xs/6 font-light'>You're currently signed in as:</div>
        <div className='whitespace-nowrap text-ellipsis overflow-hidden text-sm font-medium w-full mb-3 h-6'>{user?.email}</div>
        <Signout className='bg-zinc-100 dark:bg-zinc-800 border' />
      </div>
    </div>
  )
}
